// 配置全局访问接口地址
// let commonUrl = "//h5test.ag-lotre.com";
let commonUrl = "https://api.cre-energy.cc/";
 
let baseUrl = {
    commonUrl
}
 
export default baseUrl